"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/chooseSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ChooseSection3666sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/about/choose-img-4.png" | "/Templates/Doccure/img/about/choose-img-5.png" | "/Templates/Doccure/img/about/choose-img-6.png" | "/Templates/Doccure/img/about/choose-img-11.png" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/about/choose-icon-1.svg" | "/Templates/Doccure/img/about/choose-icon-2.svg" | "/Templates/Doccure/img/about/choose-icon-3.svg" | "/Templates/Doccure/img/about/choose-icon-4.svg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Trained Surgeons" | "Futur Technology" | "Coordinated Care" | "24/7 ENT Support" */
    h30Text: ReactNode;
    /** Detected variants: "Board-certified specialists with extensive experience in ENT." | "State of the art technology for accurate diagnosis." | "Patient-centered approach with personalized treatment plans." | "Round-the-clock availability for urgent ENT emergencies." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/about/choose-imgs-1.jpg" | "/Templates/Doccure/img/about/choose-imgs-2.jpg" | "/Templates/Doccure/img/about/choose-imgs-3.jpg" | "/Templates/Doccure/img/about/choose-imgs-4.jpg" */
    imageWithBasePath0Src2: string;
    /** Detected variants: "col-xl-3 col-lg-6 col-md-6 col-sm-6 d-flex" */
    className?: string;
    /** Detected variants: "choose-item-five flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "choose-img" */
    div0ClassName2?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "choose-content" */
    div1ClassName?: string;
    /** Detected variants: "choose-icon" */
    div0ClassName3?: string;
    /** Detected variants: "icon" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid icon-1" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "choose-imgs" */
    imageWithBasePath0Alt2?: string;
    /** Detected variants: "img-fluid bg-img" */
    imageWithBasePath0ClassName3?: string;
};
export type HomeFiveChooseSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection3666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection3666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSection3666sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection3666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "Why Choose Us" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/title-icon1.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Experience Excellence In ENT Care" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "Consult top doctors online for any health concern" */
    sectionDiv0Div2H40H4Text?: ReactNode;
    sectionDiv0Div2H40H4Visible?: boolean;
    sectionDiv0Div2H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "#" */
    sectionDiv0Div2H40Link0LinkHref?: string;
    /** Default: "Connect within 60secs" */
    sectionDiv0Div2H40Link0LinkText?: ReactNode;
    sectionDiv0Div2H40Link0LinkVisible?: boolean;
    sectionDiv0Div2H40Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2H40Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "star" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/star-icon.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    chooseSection3666s: ChooseSection3666sItem[];
    chooseSection3666sItemWrapper?: (item: ChooseSection3666sItem, content: ReactNode) => ReactNode;
    chooseSection3666sRenderer?: (defaultNode: ReactNode) => ReactNode;
    chooseSection3666sImageVisible?: boolean;
    chooseSection3666sImageRenderer?: (item: ChooseSection3666sItem, defaultNode: ReactNode) => ReactNode;
    chooseSection3666sH3Visible?: boolean;
    chooseSection3666sH3Renderer?: (item: ChooseSection3666sItem, defaultNode: ReactNode) => ReactNode;
    chooseSection3666sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ChooseSection3666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    chooseSection3666sH3Props?: Partial<ComponentProps<"h3">> | ((item: ChooseSection3666sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFiveChooseSectionGenerated: FC<HomeFiveChooseSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Why Choose Us",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/title-icon1.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Experience Excellence In ENT Care",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div2H40H4Text = "Consult top doctors online for any health concern",
    sectionDiv0Div2H40H4Visible,
    sectionDiv0Div2H40H4Renderer,
    sectionDiv0Div2H40H4Props,
    sectionDiv0Div2H40Link0LinkHref = "#",
    sectionDiv0Div2H40Link0LinkText = "Connect within 60secs",
    sectionDiv0Div2H40Link0LinkVisible,
    sectionDiv0Div2H40Link0LinkRenderer,
    sectionDiv0Div2H40Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "star",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/star-icon.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    chooseSection3666s,
    chooseSection3666sItemWrapper,
    chooseSection3666sRenderer,
    chooseSection3666sImageVisible,
    chooseSection3666sImageRenderer,
    chooseSection3666sH3Visible,
    chooseSection3666sH3Renderer,
    chooseSection3666sImageProps,
    chooseSection3666sH3Props,
}) => {
    return (
        <section className="whychoose-section-five section">
            <div className="container">
                <div className="section-header section-header-five text-center">
                    <div className="section-sub-title">
                        {" "}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {" "}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row choose-row g-4"}>
                    {renderCollectionNode(
                        chooseSection3666s,
                        (item: ChooseSection3666sItem) => (
                            <div className={item.className ?? "col-xl-3 col-lg-6 col-md-6 col-sm-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "choose-item-five flex-fill"}>
                                    <div className={item.div0ClassName2 ?? "choose-img"}>
                                        {renderItemNode(chooseSection3666sImageVisible, chooseSection3666sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof chooseSection3666sImageProps === "function" ? chooseSection3666sImageProps(item) : (chooseSection3666sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "choose-content"}>
                                        <div className={item.div0ClassName3 ?? "choose-icon"}>
                                            {renderItemNode(chooseSection3666sImageVisible, chooseSection3666sImageRenderer, item, (
                                                <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "icon"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid icon-1"} {...(typeof chooseSection3666sImageProps === "function" ? chooseSection3666sImageProps(item) : (chooseSection3666sImageProps ?? {}))} {...(typeof divDiv0Div1Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div1Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div1Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        {renderItemNode(chooseSection3666sH3Visible, chooseSection3666sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof chooseSection3666sH3Props === "function" ? chooseSection3666sH3Props(item) : (chooseSection3666sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                    {renderItemNode(chooseSection3666sImageVisible, chooseSection3666sImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath0Src2} alt={item.imageWithBasePath0Alt2 ?? "choose-imgs"} className={item.imageWithBasePath0ClassName3 ?? "img-fluid bg-img"} {...(typeof chooseSection3666sImageProps === "function" ? chooseSection3666sImageProps(item) : (chooseSection3666sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        chooseSection3666sItemWrapper,
                        chooseSection3666sRenderer
                    )}
                </div>
                <div className="view-more">
                    {renderNode(sectionDiv0Div2H40H4Visible, sectionDiv0Div2H40H4Renderer, (
                        <h4 className="view-text" {...(sectionDiv0Div2H40H4Props ?? {})}>
                            {sectionDiv0Div2H40H4Text}
                            {" "}
                            {renderNode(sectionDiv0Div2H40Link0LinkVisible, sectionDiv0Div2H40Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div2H40Link0LinkHref} className="" {...(sectionDiv0Div2H40Link0LinkProps ?? {})}>{sectionDiv0Div2H40Link0LinkText}</SmartLink>
                            ))}
                            {" "}
                        </h4>
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid star-icon star-5" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFiveChooseSectionGenerated;
